<template>
  <div class="main-container">
    <div class="dashboard">
      <div
        v-for="(data, serviceName) in serviceStatus"
        :key="serviceName"
        class="status"
        :class="{ 'green': data.status === 'healthy', 'red': data.status !== 'healthy' }"
      >
        {{ serviceName }}: {{ data.status }}
      </div>
    </div>

    <div v-if="hasUnhealthyServices" class="errors-messages">
      <strong style="color: red;">The Following Services are Unhealthy:</strong>
      <div v-for="(data, serviceName) in serviceStatus" :key="serviceName">
        <template v-if="data.response && data.response.message && data.status !== 'healthy'">
          <strong style="color: red; margin-top: 12px">
            {{ serviceName }}:
          </strong>
          {{ data.response.message }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HealthCheck",
  data() {
    return {
      serviceStatus: {}
    };
  },
  computed: {
    hasUnhealthyServices() {
      return Object.values(this.serviceStatus).some(
        service => (service.status !== 'healthy' && service.response && service.response.message)
      );
    }
  },
  mounted() {
    this.checkHealth();
  },
  methods: {
    checkHealth() {
      axios
        .get(process.env.HEALTH_CHECK_URL, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
        .then(response => {
          return response.data;
        })
        .then(data => {
          console.log(data);
          this.serviceStatus = setServiceStatus(data);
        })
        .catch(error => {
          let data = {};
          console.error(error);
          if (error.response && error.response.data) {
            console.log(error.response.data);
            data = error.response.data;
          }
          this.serviceStatus = setServiceStatus(data);
        });

      function setServiceStatus(data) {
        console.log(data);
        try {
          return {
            DynamoDB: data.DynamoDB || {status: "unhealthy", response: {message: 'DynamoDB is not available'}},
            AWSCognito: data.Cognito || {status: "unhealthy", response: {message: 'Cognito is not available'}},
            ElasticSearch: data.ElasticSearch || {
              status: "unhealthy",
              response: {message: 'ElasticSearch is not available'}
            }
          };
        } catch (error) {
          console.error(error);
          return {
            DynamoDB: {status: "unhealthy"},
            AWSCognito: {status: "unhealthy"},
            ElasticSearch: {status: "unhealthy"}
          };
        }
      }
    }
  }
};
</script>

<style>

.main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.dashboard {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.status {
  width: 160px;
  height: 160px;
  margin: 10px;
  border-radius: 50%;
  color: white;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.green {
  background-color: green;
}

.red {
  background-color: red;
}

.errors-messages {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/HealthCheck.vue